<template>
  <div class="visual-map-wrapper" :style="gradientStyle">
    <template v-for="(item, index) in visualMapName">
      <div class="name" :key="index">{{item}}</div>
    </template>
  </div>
</template>
<script>
export default {
  name: "visualMap",
  props: {
    visualMapName: {
      type: Array,
      default() {
        return ['重度', '中度', '轻度', '健康']
      }
    },
    visualMapColor: {
      type: Array,
      default() {
        return ['rgba(11, 212, 147, 0.54)', 'rgba(255, 204, 0, 0.54)', 'rgba(252, 116, 86, 0.77)']
      }
    }
  },
  computed: {
    gradientStyle() {
      const colorStops = this.visualMapColor.map((color, index, array) => {
        const position = (index / (array.length - 1)) * 100;
        return `${color} ${position}%`;
      });
      const gradientColors = colorStops.join(', ');
      return {
        background: `linear-gradient(0deg, ${gradientColors})`
      };
    }
  }
}
</script>

<style scoped lang="scss">
.visual-map-wrapper{
  width: 18px;
  height: 100%;
  display: flex;
  border-radius: 27px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;
  box-sizing: border-box;
}
.name {
  writing-mode: vertical-rl;
  text-orientation: upright;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 14.48px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}
</style>